import { BrowserRouter, Route, Routes, useLocation } from "react-router";
import "./App.css";
import Contact from "./pages/contact";
import HomePage from "./pages/home";
import DefaultLayout from "./pages/layout";
import {
  PATH_ABOUT,
  PATH_CONTACT,
  PATH_PORTFOLIO,
  PATH_SERVICE,
  PATH_SERVICE_DETAIL,
  PATH_TECHNOLOGY,
} from "./utility/constants";
import Technology from "./pages/technology";
import { useEffect } from "react";
import Services from "./pages/services";
import ServiceDetail from "./pages/serviceDetail";
import Portfolio from "./pages/portfolio";
import About from "./pages/about";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<DefaultLayout />}>
            {/* Nested routes inside layout */}
            <Route index element={<HomePage />} />
            <Route path={`${PATH_TECHNOLOGY}/:tech`} element={<Technology />} />
            <Route path={PATH_SERVICE} element={<Services />} />
            <Route
              path={`${PATH_SERVICE_DETAIL}/:service`}
              element={<ServiceDetail />}
            />
            <Route path={PATH_PORTFOLIO} element={<Portfolio />} />
            <Route path={PATH_ABOUT} element={<About />} />
            <Route path={PATH_CONTACT} element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}

export default App;
